/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import hexagonGreenUrl from '../../../assets/gems/hexagon_green.svg?inline';
export function HexagonGreen({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: hexagonGreenUrl,
        alt: "HexagonGreenImage"
    });
}
